import { IRouteChild } from '@simac/ui';
import { StagingMoveAssetRoute } from './move-asset/move-asset.routes';
import { StagingMovePalletRoute } from './move-pallet/move-pallet.routes';

export const StagingRoute: IRouteChild[] = [
  {
    title: 'MENU.FIELDSUPPORT.PROCESS-ASSET',
    icon: 'far fa-gem',
    route: StagingMoveAssetRoute,
  },
  {
    title: 'MENU.FIELDSUPPORT.MOVE-PALLET',
    icon: 'far fa-pallet-box',
    route: StagingMovePalletRoute,
  },
];
